import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { transformRequest, encryptQueryString } from "../../utils/API/requestMiddleware"
// import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const interviewAPI = createApi({
    reducerPath: 'interviewAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        //** Delete API */
        deleteInterview: builder.mutation({
            query: (id) => ({
                url: `/Interview/DeleteInterview/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllInterviewType: builder.query({
            query: () => ({
                url: '/Interview/GetAllInterviewType',
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),


        getInterviewById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Interview/GetInterviewById/?id=${Number(id)}`),
                method: 'GET',
            }),
            providesTags: ['Interview'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  Update API */
        updateInterview: builder.mutation({
            query: (Details) => ({
                url: '/Interview/UpdateInterview',
                method: 'POST',
                body: transformRequest(Details)
            }),
            invalidatesTags: ['Interview'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Add  API */ 
        addInterview: builder.mutation({
            query: (Details) => ({
                url: '/Interview/AddInterview',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getInterviewList: builder.mutation({
            query: (userQuery) => ({
                url: encryptQueryString(`/Interview/GetInterviewList`),
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        /** get Scale Type */
        getAllScaleType: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Interview/GetAllScaleType`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getInterviewRoundByCandidateId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Interview/GetInterviewRoundByCandidateId?CandidateId=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getInterviewFeedbackConfigurationByRoundId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`Interview/GetInterviewFeedbackConfigurationByRoundId?InterviewRoundId=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addInterviewFeedback: builder.mutation({
            query: (details) => ({
                url: '/Interview/AddInterviewFeedback',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Update start date 
        updateInterviewStartDate: builder.query({
            query: (scheduledInterviewId) => ({
                url: encryptQueryString(`/Candidate/UpdateInterviewStartDatebyScheduleInterviewId/?scheduledInterviewId=${scheduledInterviewId}`),
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})

export const {
    useLazyGetAllInterviewTypeQuery,
    useLazyGetInterviewByIdQuery,
    useDeleteInterviewMutation,
    useAddInterviewMutation,
    useUpdateInterviewMutation,
    useGetInterviewListMutation,
    useLazyGetAllScaleTypeQuery,

    useLazyGetInterviewRoundByCandidateIdQuery,
    useLazyGetInterviewFeedbackConfigurationByRoundIdQuery,
    useAddInterviewFeedbackMutation,
    useLazyUpdateInterviewStartDateQuery,
} = interviewAPI;

export default interviewAPI;